import { withInstall } from '@jdesign-vue/utils'
import Switch from './src/switch.vue'

export const JdSwitch = withInstall(Switch)
export default JdSwitch

export * from './src/switch'
